export const GLOBAL_I18N_VAR = 'CLOUD_I18N';
export const I18N_DEST_PATH = 'dist/public/build/i18n';
export const I18N_TYPES_PATH = 'src/i18n/keysets';
export const I18N_TYPES_FILE = 'data.json';
